export const UPCOMING = 'UPCOMING';
export const ACTIVE = 'ACTIVE';
export const FINISHED = 'FINISHED';
export const ARCHIVED = 'ARCHIVED';
